import {useContext} from 'react';
import {RouteReactContext} from './RouteReactContext';
import {RouterReactContext} from './RouterReactContext';

export function useRoute<RouteResult>() {
	const route = useContext(RouteReactContext) as RouteResult | undefined;
	const router = useContext(RouterReactContext);

	if (!router || route === undefined) {
		throw new Error('Router "useRoute": the router context is not provided');
	}

	return {route, ...router};
}

useRoute.dispalyName = 'useRoute';
